import { ref } from "vue";
import type { Usuario } from "../usuario";

export const current_user = ref<Usuario | null>(null)